"use strict";
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddParent = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var iconTypes_1 = require("../../iconTypes");
var svgIconContainer_1 = require("../../svgIconContainer");
exports.AddParent = React.forwardRef(function (props, ref) {
    var isLarge = props.size >= iconTypes_1.IconSize.LARGE;
    var pixelGridSize = isLarge ? iconTypes_1.IconSize.LARGE : iconTypes_1.IconSize.STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = { transformOrigin: "center" };
    return (React.createElement(svgIconContainer_1.SVGIconContainer, tslib_1.__assign({ iconName: "add-parent", ref: ref }, props),
        React.createElement("path", { d: isLarge ? "M360 60V220H320V260H380C391.046 260 400 251.0456 400 240V40C400 28.954 391.046 20 380 20H20C8.95432 20 0 28.954 0 40V240C0 251.0458 8.95432 260 20 260H80V220H40V60H360zM180 280H140C129 280 120 289 120 300C120 311 129 320 140 320H180V360C180 371 189 380 200 380C211 380 220 371 220 360V320H260C271 320 280 311 280 300C280 289 271 280 260 280H220V240C220 229 211 220 200 220C189 220 180 229 180 240V280z" : "M140 220H100C89 220 80 229 80 240C80 251 89 260 100 260H140V300C140 311 149 320 160 320C171 320 180 311 180 300V260H220C231 260 240 251 240 240C240 229 231 220 220 220H180V180C180 169 171 160 160 160C149 160 140 169 140 180V220zM280 40V160H260V200H304C312.836 200 320 192.8366 320 184V16C320 7.164 312.836 0 304 0H16C7.16344 0 0 7.164 0 16V184C0 192.8366 7.16344 200 16 200H60V160H40V40H280z", fillRule: "evenodd", transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"), style: style })));
});
exports.AddParent.defaultProps = {
    size: iconTypes_1.IconSize.STANDARD,
};
exports.AddParent.displayName = "Blueprint5.Icon.AddParent";
exports.default = exports.AddParent;
//# sourceMappingURL=add-parent.js.map